import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../components/common/layout/PageWrapper";
import { baseEndpointPaths, getApplicationById } from "../../../services/serviceCalls";
import RegprofAdditionalDocView from "../../components/services/additionalDoc/RegprofAdditionalDocView";

const RegprofAdditionalDocViewPage = ({ titleCode }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <PageWrapper title={t(`${titleCode}.view`)}>
      <RegprofAdditionalDocView serviceFn={getApplicationById(baseEndpointPaths.regprofAdditionalDoc, id)} />
    </PageWrapper>
  );
};
export default RegprofAdditionalDocViewPage;
